import React, { Component } from 'react'

import _ from 'lodash'

import classes from './Role.scss'
import {
  checkValidity,
  updateFormOptions,
  updateFilterOptions,
  getSelectvalue,
  getMultiSelectvalue,
  getPageStatus,
  updateObject,
  extractFilterOptions,
  validateForm
} from '../../../../helpers/utils'
import { connect } from 'react-redux'
import * as actions from '../../../../store/actions/index'

import Aux from '../../../../hoc/Auxiliary/Auxiliary'
import Alert from '../../../../components/Alert/Alert'
import Card from '../../../../components/UI/Card/Card'
import CardHeader from '../../../../components/UI/Card/Header/Header'
import CardBody from '../../../../components/UI/Card/Body/Body'
import DataTable from '../../../../components/DataTable/DataTable'
import FilterBar from '../../../../components/FilterBar/FilterBar'
import Form from '../../../../components/PageContent/SetupData/Role/Form/Form'
import Modal from '../../../../components/UI/Modal/Modal'
import ConfirmationModal from '../../../../components/ConfirmationModal/ConfirmationModal'
import FilterModal from '../../../../components/FilterModal/FilterModal'
import Spinner from '../../../../components/UI/Spinner/Spinner'
import AssignModal from '../../../../components/PageContent/SetupData/Role/AssignModal/AssignModal'
import { Checkbox } from '@material-ui/core'
import { Edit, Delete, Add, People } from '@material-ui/icons'
import { withTranslate } from 'react-redux-multilingual'
import Footer from '../../../../components/UI/Modal/Footer/Footer'
class Role extends Component {
  state = {
    modalOpen: false,
    confirmationModalOpen: false,
    filterModalOpen: false,
    roleAssignmentModalOpen: false,
    action: this.props.translate('add'),
    actionRecordId: null,
    formIsValid: false,
    searchText: '',
    form: {
      role_name: {
        label: this.props.translate('roleName'),
        elementType: 'input',
        elementConfig: {
          placeholder: this.props.translate('roleName')
        },
        value: '',
        validation: {
          required: true
        },
        valid: false,
        touched: false,
        error: null
      },
      company_id: {
        label: this.props.translate('company'),
        elementType: 'newselect',
        elementConfig: {
          type: 'text',
          placeholder: this.props.translate('company'),
          options: []
        },
        value: {},
        validation: {
          required: true
        },
        valid: false,
        touched: false,
        error: null
      },
      is_admin: {
        label: this.props.translate('admin'),
        elementType: 'checkbox',
        elementConfig: {},
        value: false,
        validation: {
          required: false
        },
        valid: true,
        touched: false,
        error: null
      },
      is_active: {
        label: this.props.translate('active'),
        elementType: 'checkbox',
        elementConfig: {},
        value: true,
        validation: {
          required: false
        },
        valid: true,
        touched: false,
        error: null
      }
    },
    filterControls: {
      role_id: {
        label: this.props.translate('role'),
        value: '',
        configs: { placeholder: this.props.translate('role'), options: [] }
      }
    },
    assignmentTabs: {
      data_access: {
        label: this.props.translate('dataAccess'),
        data: {
          corporate: {
            label: this.props.translate('corporate'),
            value: '',
            code: '',
            org_level: {
              label: this.props.translate('orgLevel'),
              value: {},
              elementConfig: {
                options: [],
                placeholder: this.props.translate('orgLevel')
              },
              inputType: 'newselect',
              valid: true
            },
            orgs: {
              label: this.props.translate('organizationName'),
              value: [],
              elementConfig: {
                options: [],
                placeholder: this.props.translate('organizationName')
              },
              inputType: 'newmultiSelect',
              validation: {
                required: true
              },
              touched: false,
              valid: false
            },
            companies: {
              label: this.props.translate('company'),
              value: [],
              elementConfig: {
                options: [],
                placeholder: this.props.translate('company')
              },
              validation: {
                required: true
              },
              touched: false,
              valid: false,
              inputType: 'newmultiSelect'
            }
          },
          individual: {
            label: this.props.translate('individual'),
            value: 'all',
            org_level: {
              label: this.props.translate('orgLevel'),
              value: '',
              elementConfig: {
                options: [],
                placeholder: this.props.translate('orgLevel')
              },
              inputType: 'newselect',
              valid: true
            },
            orgs: {
              label: this.props.translate('organization'),
              value: [],
              elementConfig: {
                options: [],
                placeholder: this.props.translate('organization')
              },
              inputType: 'newmultiSelect',
              validation: {
                required: true
              },
              touched: false,
              valid: false
            },
            companies: {
              label: this.props.translate('company'),
              value: [],
              elementConfig: {
                options: [],
                placeholder: this.props.translate('Select') + this.props.translate('company')
              },
              inputType: 'newmultiSelect',
              validation: {
                required: true
              },
              touched: false,
              valid: false
            },
            code: ''
          }
        },
        columns: {
          allCom: {
            label: this.props.translate('allCompany'),
            value: 5,
            inputType: 'radio',
            code: 'ACT05'
          },
          orgChart: {
            label: this.props.translate('orgHierarchy'),
            value: 1,
            inputType: 'radio',
            code: 'ACT01'
            // show: true
          },
          all: {
            label: this.props.translate('all'),
            value: 2,
            inputType: 'radio',
            code: 'ACT02'
          },
          ownOrg: {
            label: this.props.translate('ownOrg'),
            value: 3,
            inputType: 'radio',
            code: 'ACT03'
          },
          assignedOrg: {
            label: this.props.translate('assign') + this.props.translate('organization'),
            value: 4,
            inputType: 'radio',
            code: 'ACT04'
          }
        }
      },
      position_group_level_access: {
        label: this.props.translate('positionGroupLevelAccess'),
        data: {},
        columns: {
          checked: {
            label: this.props.translate('positionGroupLevel'),
            inputType: 'checkbox'
          }
        }
      },
      pages: {
        label: this.props.translate('pageAccess'),
        data: {},
        columns: {
          is_all: {
            label: this.props.translate('all'),
            inputType: 'checkbox'
          },
          is_view: {
            label: this.props.translate('view'),
            inputType: 'checkbox'
          },
          is_add: {
            label: this.props.translate('add'),
            inputType: 'checkbox'
          },
          is_edit: {
            label: this.props.translate('edit'),
            inputType: 'checkbox'
          },
          is_delete: {
            label: this.props.translate('delete'),
            inputType: 'checkbox'
          }
        }
      },
      users: {
        label: this.props.translate('assignUser'),
        data: {
          users: {
            label: this.props.translate('users'),
            inputType: 'newmultiSelect',
            value: [],
            elementConfig: {
              placeholder: this.props.translate('select') + this.props.translate('users'),
              options: []
            },
            touched: false,
            valid: true
          }
        }
      }
    },
    assignmentFormIsValid: false,
    currentTabIndex: 0,
    currentTab: 'data_access',
    companyOptions: [],
    orgLevelOptions: [],
    organizationOptions: [],
    empLevelOptions: [],
    positionOptions: [],
    userOptions: [],
    roleOptions: [],
    accessTypeColumns: [],
    selectedRecord: null,
    assignmentData: null,
    filterTarget: { dataKey: '', targetKey: '' },
    addAno: false
  }

  rowActions = [
    {
      icon: () => <Add />,
      tooltip: this.props.translate('add') + this.props.translate('role'),
      onClick: () => this.openModalHandler('add'),
      isFreeAction: true,
      disabled: !this.props.pagePermission.is_add
    },
    {
      icon: () => <People fontSize={'small'} />,
      tooltip: this.props.translate('assign') + this.props.translate('role'),
      onClick: (event, rowData) => this.openModalHandler('assign', rowData.role_id),
      disabled: !this.props.pagePermission.is_edit
    },
    {
      icon: () => <Edit fontSize={'small'} />,
      tooltip: this.props.translate('edit') + this.props.translate('role'),
      onClick: (event, rowData) => this.openModalHandler('edit', rowData.role_id),
      disabled: !this.props.pagePermission.is_edit
    },
    {
      icon: () => <Delete fontSize={'small'} />,
      tooltip: this.props.translate('delete') + this.props.translate('role'),
      onClick: (event, rowData) => this.openModalHandler('delete', rowData.role_id),
      disabled: !this.props.pagePermission.is_delete
    }
  ]

  tableStructure = [
    {
      field: 'index',
      title: '#',
      width: 70
    },
    { field: 'role_name', title: this.props.translate('roleName'), type: 'string' },
    { field: 'company_name', title: this.props.translate('company'), type: 'string' },
    {
      field: 'is_active',
      title: this.props.translate('active'),
      render: rowData => {
        return <Checkbox className={classes.Checkbox} checked={!!rowData.is_active} disabled />
      },
      width: 100
    }
  ]

  componentDidMount() {
    this.props.fetchRoles()
    this.props.fetchOptions()
    this.props.fetchAssignmentColumns()
    this.props.fetchFilterOptions()
    this.props.fetchAssignmentOptions()
  }

  componentDidUpdate(prevprops) {
    if (prevprops.success !== this.props.success && this.props.success) {
      this.clearModal()
    }
  }

  static getDerivedStateFromProps = (props, state) => {
    if (props.selectedRecord !== state.selectedRecord) {
      let newInputGroupState = Object.entries(state.form).reduce((formGroups, form) => {
        let [formKey, formAttrs] = form

        let value = ''
        let valid = false
        let touched = false
        let errorMessage = null
        if (formAttrs.elementType === 'checkbox') {
          value = false
        }
        if (formKey === 'is_active' && props.selectedRecord === null) {
          value = true
        }
        if (formAttrs.validation === false || formAttrs.validation.required === false) {
          valid = true
        }
        if (props.selectedRecord && props.selectedRecord[formKey]) {
          value = props.selectedRecord[formKey]

          let { isValid, error } = checkValidity(value, formAttrs.validation, formAttrs.label)
          if (formAttrs.elementType === 'checkbox') {
            value = true
          }
          if (formAttrs.elementType === 'newselect') {
            value = getSelectvalue(value, state.form[formKey].elementConfig.options)
          }
          valid = isValid
          errorMessage = error
        }

        const newFormAttrs = {
          ...formAttrs,
          value: value,
          valid: valid,
          error: errorMessage,
          touched: touched
        }

        return updateObject(formGroups, {
          [formKey]: { ...newFormAttrs }
        })
      }, {})
      let formIsValid = true

      Object.entries(newInputGroupState).map(form => {
        let [, formAttrs] = form
        return (formIsValid = formIsValid && formAttrs.valid)
      })
      return {
        form: newInputGroupState,
        formIsValid: formIsValid,
        selectedRecord: props.selectedRecord
      }
    }
    if (props.accessTypeColumns !== state.accessTypeColumns) {
      let tabs = state.assignmentTabs
      let targetTab = tabs.data_access
      let targetItem = targetTab.columns

      let updatedItem = Object.entries(targetItem).reduce((updatedColumns, column, index) => {
        let [columnKey, columnAttrs] = column

        if (props.accessTypeColumns[index]) {
          return updateObject(updatedColumns, {
            [columnKey]: {
              ...columnAttrs,
              value: props.accessTypeColumns[index].value_list_id,
              code: props.accessTypeColumns[index].value_list_code,
              label: _.camelCase(props.accessTypeColumns[index].value_list_name)
            }
          })
        }
        return updatedColumns
      }, {})

      let updatedTab = updateObject(targetTab, {
        columns: updateObject(targetTab.columns, { ...updatedItem })
      })

      return {
        assignmentTabs: updateObject(tabs, { data_access: updatedTab }),
        accessTypeColumns: props.accessTypeColumns
      }
    }
    if (props.positionGroupLevels !== state.positionGroupLevels) {
      let tabs = state.assignmentTabs
      let targetTab = tabs.position_group_level_access

      let updatedItem = props.positionGroupLevels.reduce((updatedData, data) => {
        const code = data.value_list_code
        const label = data.value_list_name
        const value = data.value_list_id
        return updateObject(updatedData, {
          [code]: {
            checked: false,
            value,
            code,
            label
          }
        })
      }, {})

      let updatedTab = updateObject(targetTab, {
        data: updateObject(targetTab.data, { ...updatedItem })
      })

      return {
        assignmentTabs: updateObject(tabs, { position_group_level_access: updatedTab }),
        positionGroupLevels: props.positionGroupLevels
      }
    }
    if (props.companyOptions !== state.companyOptions) {
      let inputForms = state.form
      let targetFormItem = inputForms.company_id
      let updatedFormItem = updateFormOptions(
        props.companyOptions,
        targetFormItem,
        'company_id',
        'company_id',
        { code: 'company_code', name: 'company_name' },
        'Select Company'
      )

      let tabs = state.assignmentTabs
      let targetTab = tabs.data_access
      let targetData = targetTab.data
      let mappedData = Object.entries(targetData).reduce((updatedData, data) => {
        let [dataKey, dataAttrs] = data
        let updatedItem = updateFormOptions(
          props.companyOptions,
          dataAttrs.companies,
          'company_id',
          'company_id',
          { code: 'company_code', name: 'company_name' },
          'Select Company'
        )

        return updateObject(updatedData, {
          [dataKey]: updateObject(dataAttrs, { companies: updatedItem })
        })
      }, {})

      return {
        form: updateObject(inputForms, { company_id: updatedFormItem }),
        assignmentTabs: updateObject(tabs, {
          data_access: {
            ...targetTab,
            data: mappedData
          }
        }),
        companyOptions: props.companyOptions
      }
    }
    if (props.orgLevelOptions !== state.orgLevelOptions) {
      const tabs = state.assignmentTabs
      const targetTab = tabs.data_access
      const targetData = targetTab.data
      const targetRowCorporate = targetData.corporate
      const targetRowIndividual = targetData.individual
      const updatedEmpDropdown = updateFormOptions(
        props.orgLevelOptions,
        targetRowIndividual.org_level,
        'level_id',
        'level_id',
        {
          code: 'level_code',
          name: 'level_name',
          additionalCode: { key: 'company_code', position: 'prepend' },
          additionalName: { key: 'company_name', position: 'prepend' }
        },
        'Select Org Level'
      )
      const updatedOrgDropdown = updateFormOptions(
        props.orgLevelOptions,
        targetRowCorporate.org_level,
        'level_id',
        'level_id',
        {
          code: 'level_code',
          name: 'level_name',
          additionalCode: { key: 'company_code', position: 'prepend' },
          additionalName: { key: 'company_name', position: 'prepend' }
        },
        'Select Org Level'
      )

      const updatedRowIndividual = updateObject(targetRowIndividual, {
        org_level: updatedEmpDropdown
      })
      const updatedRowCorporate = updateObject(targetRowCorporate, {
        org_level: updatedOrgDropdown
      })
      const updatedData = updateObject(targetData, {
        corporate: updatedRowCorporate,
        individual: updatedRowIndividual
      })
      const updatedTab = updateObject(targetTab, { data: updatedData })
      const updatedTabs = updateObject(tabs, { data_access: updatedTab })

      return {
        assignmentTabs: updatedTabs,
        orgLevelOptions: props.orgLevelOptions
      }
    }
    if (props.organizationOptions !== state.organizationOptions) {
      let tabs = state.assignmentTabs
      let targetTab = tabs.data_access
      let targetData = targetTab.data
      let mappedData = Object.entries(targetData).reduce((updatedData, data) => {
        let [dataKey, dataAttrs] = data
        let updatedItem = updateFormOptions(
          props.organizationOptions,
          dataAttrs.orgs,
          'org_id',
          'org_id',
          {
            code: 'org_code',
            name: 'org_name'
          },
          'Select Organization'
        )

        return updateObject(updatedData, {
          [dataKey]: updateObject(dataAttrs, { orgs: updatedItem })
        })
      }, {})

      return {
        assignmentTabs: updateObject(tabs, {
          data_access: {
            ...targetTab,
            data: mappedData
          }
        }),
        organizationOptions: props.organizationOptions
      }
    }
    if (props.filteredOrgOptions !== state.filteredOrgOptions) {
      if (state.filterTarget.dataKey) {
        let tabs = state.assignmentTabs
        let targetTab = tabs.data_access
        let targetData = targetTab.data
        let dataKey = state.filterTarget.dataKey
        let targetDataAttrs = targetData[dataKey]

        let updatedItem = updateFormOptions(
          props.filteredOrgOptions,
          targetDataAttrs.orgs,
          'org_id',
          'org_id',
          'org_name',
          'Select Organization',
          false,
          true
        )

        let updatedData = updateObject(targetData, {
          [dataKey]: updateObject(targetDataAttrs, { orgs: updatedItem })
        })

        return {
          assignmentTabs: updateObject(tabs, {
            data_access: updateObject(targetTab, { data: updatedData })
          }),
          filteredOrgOptions: props.filteredOrgOptions
        }
      }
    }
    if (props.userOptions !== state.userOptions) {
      let tabs = state.assignmentTabs
      let targetTab = tabs.users
      let targetItem = targetTab.data.users
      let updatedItem = updateFormOptions(
        props.userOptions,
        targetItem,
        'user_id',
        'user_id',
        'user_name',
        'Select User'
      )

      return {
        assignmentTabs: updateObject(tabs, {
          users: {
            ...targetTab,
            data: updateObject(targetTab.data, { users: updatedItem })
          }
        }),
        userOptions: props.userOptions
      }
    }
    if (props.roleOptions !== state.roleOptions) {
      let item = state.filterControls.role_id
      let updatedItem = updateFilterOptions(
        props.roleOptions,
        item,
        'role_id',
        'role_id',
        'role_name',
        'Select Role'
      )

      return {
        filterControls: updateObject(state.filterControls, { role_id: updatedItem }),
        roleOptions: props.roleOptions
      }
    }
    if (props.assignmentData !== state.assignmentData) {
      const pglCodes = (props.assignmentData.position_group_level_access || []).map(
        item => item.position_group_level_code
      )
      let assignmentValid = true

      let newAssignmentData = Object.entries(state.assignmentTabs).reduce((updatedTabs, tab) => {
        let [tabKey, tabAttrs] = tab
        let data = props.assignmentData[tabKey] // data, columns, label
        if (data.length < 1 && tabKey !== 'position_group_level_access') {
          return updateObject(updatedTabs, {
            [tabKey]: {
              ...tabAttrs
            }
          })
        } else if (tabKey === 'pages') {
          let isViewAll = true
          let isAddAll = true
          let isEditAll = true
          let isDeleteAll = true

          data.forEach(item => {
            isViewAll = isViewAll && !!item.is_view
            isAddAll = isAddAll && !!item.is_add
            isEditAll = isEditAll && !!item.is_edit
            isDeleteAll = isDeleteAll && !!item.is_delete
          })

          const isAll = isViewAll && isAddAll && isEditAll && isDeleteAll
          data = [
            {
              page_name: 'all',
              is_all: isAll,
              is_view: isViewAll,
              is_add: isAddAll,
              is_edit: isEditAll,
              is_delete: isDeleteAll
            },
            ...data
          ]
        } else if (tabKey === 'position_group_level_access') {
          data = tabAttrs.data
        }

        let mappedData = Object.entries(data).reduce((updatedData, dataItem) => {
          let [, recordData] = dataItem
          switch (tabKey) {
            case 'data_access':
              let dataKey = recordData.appraisal_type_name.toLowerCase()
              let code = recordData.access_type_code

              let companies = {
                ...tabAttrs.data[dataKey].companies,
                value: getMultiSelectvalue(
                  recordData.companies,
                  tabAttrs.data[dataKey].companies.elementConfig.options,
                  'company_id'
                )
              }

              let org_levelValue = getSelectvalue(
                null,
                tabAttrs.data[dataKey].org_level.elementConfig.options
              )

              let org_level = {
                ...tabAttrs.data[dataKey].org_level,
                value: org_levelValue
              }

              let orgs = {
                ...tabAttrs.data[dataKey].orgs,
                value: getMultiSelectvalue(
                  recordData.orgs,
                  tabAttrs.data[dataKey].orgs.elementConfig.options,
                  'organization_id'
                )
              }

              if (!code) {
                assignmentValid = false
              }
              switch (code) {
                case 'ACT01':
                  companies = {
                    ...companies,
                    validation: { required: true, isArray: true },
                    touched: false,
                    valid: recordData.companies.length > 0
                  }
                  orgs = {
                    ...orgs,
                    validation: { required: false, isArray: true },
                    touched: false,
                    valid: true
                  }
                  if (companies.value?.length === 0) {
                    assignmentValid = false
                  }
                  break
                case 'ACT02':
                  companies = {
                    ...companies,
                    validation: { required: false, isArray: true },
                    touched: false,
                    valid: true
                  }
                  orgs = {
                    ...orgs,
                    validation: { required: true, isArray: true },
                    touched: false,
                    valid: recordData.orgs.length > 0
                  }
                  if (orgs.value?.length === 0) {
                    assignmentValid = false
                  }
                  break
                default:
                  companies = {
                    ...companies,
                    validation: { required: false, isArray: true },
                    touched: false,
                    valid: true
                  }
                  orgs = {
                    ...orgs,
                    validation: { required: false, isArray: true },
                    touched: false,
                    valid: true
                  }
                  break
              }

              if (tabAttrs.data[dataKey]) {
                let updatedAttrs = {
                  [dataKey]: updateObject(recordData, {
                    value: recordData.access_type_id,
                    label: recordData.appraisal_type_name,
                    code: code,
                    companies,
                    org_level,
                    orgs
                  })
                }

                return updateObject(updatedData, { ...updatedAttrs })
              }
              return updatedData
            case 'pages':
              let pageKey = _.camelCase(recordData.page_name)
              const { is_view, is_add, is_edit, is_delete } = recordData
              recordData = {
                ...recordData,
                is_view: !!is_view,
                is_add: !!is_add,
                is_edit: !!is_edit,
                is_delete: !!is_delete,
                is_all: is_view && is_add && is_edit && is_delete,
                page_name: pageKey
              }
              let updatedAttrs = {
                [pageKey]: {
                  ...recordData
                }
              }

              return updateObject(updatedData, { ...updatedAttrs })
            case 'position_group_level_access':
              assignmentValid = Object.keys(data).length > 0 && assignmentValid
              const pglCode = recordData.code
              const base = data[pglCode] || null
              const checked = pglCodes.includes(pglCode)

              if (!base) {
                return updatedData
              }

              const updatedRecordData = {
                ...base,
                checked
              }
              let updatedGroupAttrs = {
                [pglCode]: {
                  ...updatedRecordData
                }
              }

              return updateObject(updatedData, { ...updatedGroupAttrs })
            case 'users':
              assignmentValid = data.length > 0 && assignmentValid
              let updatedFormItem = updateObject(tabAttrs.data, {
                users: {
                  ...tabAttrs.data.users,
                  value: getMultiSelectvalue(
                    data,
                    state.assignmentTabs.users.data.users.elementConfig.options
                  ),
                  valid: data.length > 0
                }
              })
              return updateObject(updatedData, { ...updatedFormItem })
            default:
              return tabAttrs.data
          }
        }, {})

        return updateObject(updatedTabs, {
          [tabKey]: {
            ...tabAttrs,
            data: mappedData
          }
        })
      }, {})

      return {
        assignmentTabs: newAssignmentData,
        assignmentFormIsValid: assignmentValid,
        assignmentData: props.assignmentData
      }
    }
    return null
  }

  onPageChangeHandler = (event, page) => {
    const pageOptions = {
      page: page,
      perPage: this.props.pagination.perPage
    }
    const payload = extractFilterOptions(this.state.filterControls, pageOptions)
    this.props.fetchRoles(payload)
  }

  onPerPageChangeHandler = perPage => {
    const pageOptions = {
      page: this.props.pagination.currentPage,
      perPage: perPage
    }
    const payload = extractFilterOptions(this.state.filterControls, pageOptions)
    this.props.fetchRoles(payload)
  }

  searchInputChangeHandler = e => {
    const searchText = e.target.value
    this.setState({
      searchText: searchText
    })
  }

  openModalHandler = (action, recordId) => {
    this.setState({
      action: action,
      actionRecordId: recordId
    })

    if (action === 'delete') {
      this.openConfirmationModal(recordId)
    } else if (action === 'assign') {
      // this.props.fetchAssignmentOptions()
      this.props.fetchRoleAssignmentData(recordId)
      this.openRoleAssignmentModal()
    } else if (action === 'edit') {
      this.props.fetchOptions()
      this.props.fetchRoleById(recordId)
      this.openModal()
    } else {
      this.props.fetchOptions()
      this.openModal()
    }
  }

  openModal = () => {
    if (this.state.action === 'add') {
      this.setState({
        formIsValid: false
      })
    }
    this.setState({
      modalOpen: true
    })
  }

  closeModal = () => {
    if (this.state.action === 'edit') {
      this.clearModal()
    } else {
      this.setState({
        modalOpen: false
      })
    }
  }
  clearModal = () => {
    let newInputGroupState = Object.entries(this.state.form).reduce((formGroups, form) => {
      let [formKey, formAttrs] = form

      let value = ''
      let valid = false
      let touched = false
      let errorMessage = null
      if (formAttrs.elementType === 'checkbox') {
        value = false
      }
      if (formKey === 'is_active') {
        value = true
      }
      if (formAttrs.validation === false || formAttrs.validation.required === false) {
        valid = true
      }
      const newFormAttrs = {
        ...formAttrs,
        value: value,
        valid: valid,
        error: errorMessage,
        touched: touched
      }

      return {
        ...formGroups,
        [formKey]: { ...newFormAttrs }
      }
    }, {})
    this.closeRoleAssignmentModal()
    this.props.clearSelectedRecord()
    if (this.state.addAno) {
      this.setState({
        form: newInputGroupState,
        actionRecordId: null,
        addAno: false
      })
    } else {
      this.setState({
        form: newInputGroupState,
        actionRecordId: null,
        modalOpen: false
      })
    }
  }
  openRoleAssignmentModal = () => {
    this.setState({
      roleAssignmentModalOpen: true
    })
  }

  closeRoleAssignmentModal = () => {
    // this.props.clearSelectedRecord()
    this.setState({
      roleAssignmentModalOpen: false,
      currentTab: 'data_access',
      currentTabIndex: 0
    })
  }

  assignmentInputChangeHandler = (dataKey, formKey, inputType, event) => {
    const currentTab = this.state.currentTab
    const targetTab = this.state.assignmentTabs[currentTab]
    const targetData = targetTab.data[dataKey]
    let accessTypeCode = null
    let value = null

    let companies = null
    let orgs = null

    let updatedTabs = null

    let assignmentData = this.state.assignmentTabs.data_access.data[dataKey]

    if (assignmentData && currentTab === 'data_access') {
      companies = this.state.assignmentTabs.data_access.data[dataKey].companies
      orgs = this.state.assignmentTabs.data_access.data[dataKey].orgs
    }

    if (['newselect'].includes(inputType)) {
      value = event
    } else if (inputType === 'newmultiSelect') {
      value = event
    } else if (inputType === 'checkbox') {
      value = event.target.checked
    } else if (inputType === 'radio') {
      value = +event.target.value

      accessTypeCode = event.code
    } else {
      value = event.target.value
    }

    if (accessTypeCode && currentTab === 'data_access') {
      let companiesRequired = accessTypeCode === 'ACT01'
      let orgsRequired = accessTypeCode === 'ACT02'
      companies = {
        ...companies,
        value: [],
        validation: { required: companiesRequired, isArray: true },
        touched: false,
        valid: !companiesRequired || companies.value.length > 0
      }

      orgs = {
        ...orgs,
        value: [],
        validation: { required: orgsRequired, isArray: true },
        touched: false,
        valid: !orgsRequired || orgs.value.length > 0
      }
    }

    if (currentTab === 'position_group_level_access') {
      let updatedData = value

      let updatedTabData = updateObject(targetTab.data, {
        [dataKey]: updateObject(targetData, { [formKey]: updatedData })
      })

      updatedTabs = updateObject(this.state.assignmentTabs, {
        [currentTab]: updateObject(targetTab, { data: updatedTabData })
      })
    } else if (formKey) {
      // Pages & Input (Data Access)
      let updatedData = value
      let oldData = targetData[formKey]
      let { isValid, error } = checkValidity(value, oldData.validation, oldData.label)

      if (typeof oldData === 'object') {
        updatedData = { ...oldData, value, valid: isValid, error, touched: true }
      }

      let updatedTabData = updateObject(targetTab.data, {
        [dataKey]: updateObject(targetData, { [formKey]: updatedData })
      })

      if (currentTab === 'pages') {
        if (dataKey === 'all') {
          if (formKey === 'is_all') {
            updatedTabData = Object.entries(targetTab.data).reduce((updated, item) => {
              const [itemKey, itemData] = item
              return {
                ...updated,
                [itemKey]: {
                  ...itemData,
                  is_all: value,
                  is_view: value,
                  is_add: value,
                  is_edit: value,
                  is_delete: value
                }
              }
            }, {})
          } else {
            updatedTabData = Object.entries(targetTab.data).reduce((updated, item) => {
              const [itemKey, itemData] = item
              let updatedItemData = updateObject(itemData, { [formKey]: value })
              const { is_add, is_edit, is_delete, is_view } = updatedItemData
              return updateObject(updated, {
                [itemKey]: { ...updatedItemData, is_all: is_view && is_add && is_edit && is_delete }
              })
            }, {})
          }
        } else {
          if (formKey === 'is_all') {
            updatedTabData = updateObject(targetTab.data, {
              [dataKey]: updateObject(targetData, {
                is_all: value,
                is_view: value,
                is_add: value,
                is_edit: value,
                is_delete: value
              })
            })
          } else {
            const updatedItem = updateObject(targetData, { [formKey]: value })
            const { is_view, is_add, is_edit, is_delete } = updatedItem
            updatedTabData = updateObject(targetTab.data, {
              [dataKey]: updateObject(updatedItem, {
                is_all: is_view && is_add && is_edit && is_delete
              })
            })
          }
          const { isViewAll, isAddAll, isEditAll, isDeleteAll } = Object.entries(
            updatedTabData
          ).reduce(
            (updated, page) => {
              const [, pageData] = page
              if (pageData.page_name === 'All') {
                return updated
              }
              return {
                isViewAll: updated.isViewAll && pageData.is_view,
                isAddAll: updated.isAddAll && pageData.is_add,
                isEditAll: updated.isEditAll && pageData.is_edit,
                isDeleteAll: updated.isDeleteAll && pageData.is_delete
              }
            },
            { isViewAll: true, isAddAll: true, isEditAll: true, isDeleteAll: true }
          )

          updatedTabData = updateObject(updatedTabData, {
            all: {
              ...updatedTabData.all,
              is_view: isViewAll,
              is_add: isAddAll,
              is_edit: isEditAll,
              is_delete: isDeleteAll,
              is_all: isViewAll && isAddAll && isEditAll && isDeleteAll
            }
          })
        }
      }

      updatedTabs = updateObject(this.state.assignmentTabs, {
        [currentTab]: updateObject(targetTab, { data: updatedTabData })
      })
    } else if (dataKey === 'users') {
      let updatedData = value
      let oldData = targetData
      let { isValid, error } = checkValidity(value, oldData.validation, oldData.label)

      if (typeof oldData === 'object') {
        updatedData = { ...oldData, value, valid: isValid, error, touched: true }
      }

      updatedTabs = updateObject(this.state.assignmentTabs, {
        [currentTab]: updateObject(targetTab, {
          data: {
            users: updatedData
          }
        })
      })
    } else {
      // Radio (Data Access)
      updatedTabs = updateObject(this.state.assignmentTabs, {
        [currentTab]: updateObject(targetTab, {
          data: updateObject(targetTab.data, {
            [dataKey]: updateObject(targetData, {
              code: accessTypeCode,
              value: value,
              companies,
              orgs
            })
          })
        })
      })
    }

    let dataAccessValid = Object.entries(updatedTabs.data_access.data).reduce(
      (dataValid, dataItem) => {
        let [, dataAttr] = dataItem
        let dataItemValid = Object.entries(dataAttr).reduce((formValid, formItem) => {
          let [formKey, formAttr] = formItem
          if (['companies', 'orgs'].includes(formKey)) {
            return formValid && formAttr.valid
          } else {
            return formValid
          }
        }, true)
        return dataValid && dataItemValid
      },
      true
    )

    this.setState({
      ...this.state,
      assignmentTabs: updatedTabs,
      assignmentFormIsValid: dataAccessValid
    })
  }

  assignmentFilterInputChangeHandler = (event, dataKey, filterKey, targetKey) => {
    let value = event
    const tabs = this.state.assignmentTabs
    const targetTab = tabs.data_access
    const targetData = targetTab.data[dataKey]
    const targetItem = targetData.org_level
    switch (targetKey) {
      case 'orgs':
        this.props.filterOrganizationOptions({ [filterKey]: value.value })
        this.setState({
          assignmentTabs: updateObject(tabs, {
            data_access: updateObject(targetTab, {
              data: updateObject(targetTab.data, {
                [dataKey]: updateObject(targetData, {
                  org_level: updateObject(targetItem, { value: value })
                })
              })
            })
          }),
          filterTarget: { dataKey, targetKey }
        })
        break
      default:
        break
    }
  }

  roleAssignmentHandler = () => {
    let assignmentData = Object.entries(this.state.assignmentTabs).reduce((data, tab) => {
      let [tabKey, tabAttr] = tab

      let tabData = Object.entries(tabAttr.data).reduce((tabData, dataItem) => {
        let [dataKey, dataAttr] = dataItem
        // delete dataAttr.org_level
        if (tabKey === 'data_access') {
          return [
            ...tabData,
            {
              ...dataAttr,
              access_type_id: dataAttr.value,
              companies: dataAttr.companies.value.map(item => item.value),
              orgs: dataAttr.orgs.value.map(item => item.value)
            }
          ]
        }

        if (tabKey === 'position_group_level_access') {
          if (dataAttr.checked) {
            return [...tabData, dataAttr.value]
          }
          return tabData
        }

        if (tabKey === 'users' && dataKey === 'users') {
          return dataAttr.value.map(item => item.value)
        }

        if (tabKey === 'pages' && dataKey === 'all') {
          return tabData
        }
        return [...tabData, dataAttr]
        // return { ...tabData, [dataKey]: dataAttr.value }
      }, [])

      return { ...data, [tabKey]: tabData }
    }, {})
    this.props.assignRole(this.state.actionRecordId, assignmentData)
  }

  tabChangeHandler = (event, tabIndex) => {
    let tabKey = null
    switch (tabIndex) {
      case 0:
        tabKey = 'data_access'
        break
      case 1:
        tabKey = 'position_group_level_access'
        break
      case 2:
        tabKey = 'pages'
        break
      case 3:
        tabKey = 'users'
        break
      default:
        break
    }
    this.setState({ currentTab: tabKey, currentTabIndex: tabIndex })
  }

  formSubmitHandler = type => {
    const formData = Object.entries(this.state.form).reduce((formData, formEntry) => {
      let [formKey, formAttrs] = formEntry
      let value = ''
      if (formAttrs.elementType === 'newselect') {
        value = formAttrs.value?.value
      } else {
        value = formAttrs.value
      }
      return { ...formData, [formKey]: value }
    }, {})

    if (this.state.action === 'add') {
      this.props.createRole({ ...formData }, getPageStatus(this.props.pagination, false))
      if (type === 'saveAno') {
        this.setState({
          addAno: true
        })
      }
    } else {
      this.props.updateRole(
        this.state.actionRecordId,
        { ...formData },
        getPageStatus(this.props.pagination, false)
      )
    }
  }

  deleteRecord = () => {
    const recordId = this.state.actionRecordId

    this.props.deleteRole(recordId, getPageStatus(this.props.pagination, true))

    this.closeConfirmationModal()
  }

  inputChangeHandler = (formKey, event) => {
    const formItem = this.state.form[formKey]

    let inputValue = ''

    if (formItem.elementType === 'textEditor') {
      inputValue = event.target.getContent()
    } else if (formItem.elementType === 'newselect') {
      inputValue = event
    } else if (formItem.elementType === 'checkbox') {
      inputValue = event.target.checked
    } else {
      inputValue = event.target.value
    }

    const { isValid, error } = checkValidity(inputValue, formItem.validation, formItem.label)

    const updatedFormItem = {
      ...formItem,
      value: inputValue,
      valid: isValid,
      error: error,
      touched: true
    }

    const updatedForm = updateObject(this.state.form, { [formKey]: updatedFormItem })

    let formIsValid = true

    Object.entries(updatedForm).map(form => {
      let [, formAttrs] = form
      return (formIsValid = formIsValid && formAttrs.valid)
    })

    this.setState({
      form: updatedForm,
      formIsValid: formIsValid
    })
  }

  closeConfirmationModal = () => {
    this.setState({
      confirmationModalOpen: false,
      actionRecordId: null
    })
  }

  openConfirmationModal = recordId => {
    if (recordId) {
      this.setState({
        confirmationModalOpen: true
      })
    }
  }

  closeFilterModal = () => {
    this.setState({
      filterModalOpen: false
    })
  }

  openFilterModal = () => {
    this.props.fetchFilterOptions()
    this.setState({
      filterModalOpen: true
    })
  }

  handleFilterChange = (itemKey, e) => {
    const filterValue = e
    const filterItem = this.state.filterControls[itemKey]
    this.setState({
      filterControls: updateObject(this.state.filterControls, {
        [itemKey]: {
          ...filterItem,
          value: filterValue
        }
      })
    })
  }

  filterRecords = () => {
    const filters = Object.entries(this.state.filterControls).reduce((filters, filterItem) => {
      const [filterKey, filterAttrs] = filterItem
      return { ...filters, [filterKey]: filterAttrs.value?.value || null }
    }, {})

    this.props.fetchRoles({
      page: 1,
      perPage: 10,
      ...filters
    })

    this.setState({
      filterModalOpen: false
    })
  }

  render() {
    let formGroup = <Spinner />
    let form = (
      <Form
        saved={(formData, event) => this.formSubmitHandler(formData, event)}
        cancelled={this.closeModal}
        form={this.state.form}
        inputChanged={(formKey, e) => this.inputChangeHandler(formKey, e)}
        formValid={this.state.formIsValid}
        selectedRecord={this.props.selectedRecord}
      />
    )

    if (this.state.action === 'edit') {
      if (this.state.selectedRecord && !this.props.loading) {
        formGroup = form
      }
    } else if (!this.props.loading) {
      formGroup = form
    }
    const footer = (
      <Footer
        save={() => this.formSubmitHandler('save')}
        another={() => this.formSubmitHandler('saveAno')}
        showAnother={this.state.action === 'add'}
        cancel={() => this.closeModal()}
        disable={!validateForm(this.state.form)}
      />
    )
    // const buttonGroups = (
    //   <div className={classes.ButtonGroup}>
    //     <span className={classes.Button}>
    //       <Button
    //         color={'primary'}
    //         clicked={this.formSubmitHandler}
    //         disabled={!this.state.formIsValid}>
    //         {this.props.translate('save')}
    //       </Button>
    //     </span>
    //     <span className={classes.Button}>
    //       <Button color={'default'} clicked={this.clearModal}>
    //         {this.props.translate('cancel')}
    //       </Button>
    //     </span>
    //   </div>
    // )

    return (
      <Aux>
        <ConfirmationModal
          open={this.state.confirmationModalOpen}
          cancelled={this.closeConfirmationModal}
          confirmed={this.deleteRecord}
          promptText={this.props.translate('confirmDel')}
        />
        <FilterModal
          open={this.state.filterModalOpen}
          cancelled={this.closeFilterModal}
          filterSaved={this.filterRecords}
          filterChanged={(itemKey, e) => this.handleFilterChange(itemKey, e)}
          filterControls={this.state.filterControls}
        />
        <AssignModal
          open={this.state.roleAssignmentModalOpen}
          cancelled={this.closeRoleAssignmentModal}
          loading={this.props.assignmentLoading}
          assignmentData={this.state.assignmentTabs}
          formIsValid={this.state.assignmentFormIsValid}
          currentTabIndex={this.state.currentTabIndex}
          tabChanged={this.tabChangeHandler}
          inputChanged={this.assignmentInputChangeHandler}
          filterInputChanged={this.assignmentFilterInputChangeHandler}
          onAssigned={this.roleAssignmentHandler}
        />
        <Alert />
        <Modal
          open={this.state.modalOpen}
          onHide={this.closeModal}
          header={this.props.translate(this.state.action) + this.props.translate('role')}
          footer={footer}>
          {formGroup}
        </Modal>
        <div className={classes.RoleWrapper}>
          <Card>
            <CardHeader>
              <FilterBar buttonClicked={this.openFilterModal} />
            </CardHeader>
            <CardBody>
              <DataTable
                tableTitle={this.props.translate('role')}
                data={this.props.data}
                structure={this.tableStructure}
                loading={this.props.loading}
                pagination={this.props.pagination}
                pageChange={this.onPageChangeHandler}
                perPageChange={this.onPerPageChangeHandler}
                rowActions={this.rowActions}
              />
            </CardBody>
          </Card>
        </div>
      </Aux>
    )
  }
}

const mapStateToProps = state => {
  return {
    pagination: state.roles.pagination,
    data: state.roles.records,
    loading: state.roles.loading,
    filterLoading: state.roles.filterLoading,
    success: state.roles.success,
    assignmentLoading: state.roles.assignmentLoading,
    selectedRecord: state.roles.selectedRecord,
    assignmentData: state.roles.assignmentData,
    companyOptions: state.roles.companies,
    orgLevelOptions: state.roles.orgLevels,
    empLevelOptions: state.roles.empLevels,
    organizationOptions: state.roles.organizations,
    positionGroupLevels: state.roles.positionGroupLevels,
    positionOptions: state.roles.positions,
    userOptions: state.roles.users,
    accessTypeColumns: state.roles.accessTypes,
    filteredOrgOptions: state.roles.filteredOrganizations,
    roleOptions: state.roles.roles
  }
}

const mapDispatchToProps = dispatch => {
  return {
    fetchRoles: filterOptions => dispatch(actions.fetchRoles(filterOptions)),
    fetchRoleById: recordId => dispatch(actions.fetchRoleById(recordId)),
    fetchRoleAssignmentData: recordId => dispatch(actions.fetchRoleAssignmentData(recordId)),
    clearSelectedRecord: () => dispatch(actions.clearSelectedRoleRecord()),
    createRole: (recordData, page) => dispatch(actions.createRole(recordData, page)),
    assignRole: (recordId, assignmentData) =>
      dispatch(actions.assignRole(recordId, assignmentData)),
    updateRole: (recordId, recordData, page) =>
      dispatch(actions.updateRole(recordId, recordData, page)),
    deleteRole: (recordId, page) => dispatch(actions.deleteRole(recordId, page)),
    fetchOptions: () => {
      dispatch(actions.fetchCompanyOptions())
    },
    fetchAssignmentColumns: () => {
      dispatch(actions.fetchAccessTypeOptions())
    },
    fetchAssignmentOptions: () => {
      dispatch(actions.fetchCompanyOptions())
      dispatch(actions.fetchOrgLevelOptions())
      dispatch(actions.fetchOrganizationOptions())
      dispatch(actions.fetchEmpLevelOptions())
      dispatch(actions.fetchPositionOptions())
      dispatch(actions.fetchPositionGroupLevelOptions())
      dispatch(actions.fetchUserOptions())
    },
    filterOrganizationOptions: filterOptions => {
      dispatch(actions.filterOrganizationOptions(filterOptions))
    },
    fetchFilterOptions: () => dispatch(actions.fetchRoleOptions())
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslate(Role))
